<template>
  <div>
    <header class="vff-header">
      <div class="f-container">
        <!-- Add custom logo here -->
        <img
          class="f-logo"
          src="@/assets/imagens/logo-leportini.png"
          alt="Leportini Cosméticos"
          style="width: 80px; height: auto;"
        >
      </div>
    </header>

    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-on:submit="onSubmit"
      v-on:answer="onAnswer"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="true"
    >
      <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
        <div class="f-section-wrap">
          <p>
            <span class="fh2">Prestes a Completar Nossa Missão!</span>
            <span class="f-section-text">
              Clique em 'Enviar' para Prosseguir ou 'Voltar' para Revisar.
            </span>
          </p>
        </div>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit" v-if="!submitted">
          <button
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Pressione para Enviar"
          >
            <span>{{ language.submitText }}</span>
          </button>
          <a
            class="f-enter-desc"
            href="#"
            v-on:click.prevent="onSendData()"
            v-html="language.formatString(language.pressEnter)"
          >
          </a>
        </div>

        <div v-if="submitted">
          <p class="text-success">Seu Diagnóstico Capilar Foi Enviado com Sucesso!</p>
          <p class="text-success">Conecte-se Conosco no Instagram e Explore Nossa Loja Online!</p>

          <!-- Adicionando imagem com link após a mensagem de sucesso -->
          <a href="https://www.instagram.com/leportini/" target="_blank">
            <img src="@/assets/imagens/instagram-leportini.png" style="width: 50px; height: auto; margin: 5px;">
          </a>
          <a href="https://loja.leportini.com.br" target="_blank">
            <img src="@/assets/imagens/loja-leportini.png" style="width: 50px; height: auto; margin: 5px;">
          </a>
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
import { FlowForm } from '@ditdot-dev/vue-flow-form'
import { QuestionModel, QuestionType, ChoiceOption, LanguageModel, LinkOption } from '@ditdot-dev/vue-flow-form'

export default {
  components: {
    FlowForm
  },
  data() {
    const language = new LanguageModel({
      continue: 'Continuar',
      pressEnter: 'Pressione ENTER',
      otherPrompt: 'OUTROS PROCESSOS QUÍMICOS',
      submitText: 'Enviar',
      skip: 'pular',
      invalidPrompt: 'Por favor, preencha o campo corretamente.',
      multipleChoiceHelpTextSingle: 'Seu diagnóstico personalizado está sendo preparado.'
    })
    return {
      submitted: false,
      completed: false,
      language,
      defaultInvalidPrompt: language.invalidPrompt,
      // Create question list with QuestionModel instances
      questions: [
        new QuestionModel({
          id: 'sexo',
          tagline: 'Encontrar a rotina de cuidados perfeita para o seu cabelo é essencial. Um cabelo bonito começa com um bom diagnóstico, vamos começar! 😉',
          title: 'Você é?',
          helpTextShow: false,
          type: QuestionType.MultiplePictureChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/mulher.webp'),
              imageAlt: 'mulher',
              label: 'Uma Mulher',
              value: 'F'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/homem.webp'),
              imageAlt: 'homem',
              label: 'Um Homem',
              value: 'M'
            })
          ],
          jump: {
            F: 'nomeFeminino',
            M: 'nomeMasculino'
          }
        }),
        new QuestionModel({
          id: 'nomeFeminino',
          tagline: 'Nós gostaríamos conhecê-la. 😊',
          title: 'Qual é o seu nome?',
          type: QuestionType.Text,
          required: true,
          placeholder: 'Por favor, digite o seu nome aqui...',
          jump: {
            _other: 'emailFeminino'
          }
        }),
        new QuestionModel({
          id: 'nomeMasculino',
          tagline: 'Nós gostaríamos conhecê-lo. 😊',
          title: 'Qual é o seu nome?',
          type: QuestionType.Text,
          required: true,
          placeholder: 'Por favor, digite o seu nome aqui...',
          jump: {
            _other: 'emailMasculino'
          }
        }),
        new QuestionModel({
          id: 'emailFeminino',
          tagline: 'Prazer em conhecê-la 👀, vamos continuar:',
          title: 'Informe seu e-mail para enviarmos seu diagnóstico.',
          type: QuestionType.Email,
          required: true,
          placeholder: 'Digite aqui o seu melhor e-mail...',
          jump: {
            _other: 'perguntaIntencionalDor'
          }
        }),
        new QuestionModel({
          id: 'emailMasculino',
          tagline: 'Prazer em conhecê-lo 👀, vamos continuar.',
          title: 'Informe seu e-mail para enviarmos seu diagnóstico:',
          type: QuestionType.Email,
          required: true,
          placeholder: 'Digite aqui o seu melhor e-mail...'
        }),
        new QuestionModel({
          id: 'perguntaIntencionalDor',
          title: 'O que mais te incomoda no seu cabelo hoje e você gostaria de mudar?',
          type: QuestionType.LongText,
          required: true,
          placeholder: '(Ex: ressecamento, frizz, queda, volume, oleosidade...)'
        }),
        new QuestionModel({
          id: 'tipoCabelo',
          title: 'Qual é o tipo do seu cabelo?',
          type: QuestionType.MultipleChoice,
          multiple: false,
          helpText: 'Escolha a opção que melhor descreve a condição geral do seu cabelo, considerando a oleosidade e a textura dos fios',
          required: true,
          options: [
            new ChoiceOption({
              label: 'SECOS', value: '1: Secos'
            }),
            new ChoiceOption({
              label: 'OLEOSOS', value: '2: Oleosos'
            }),
            new ChoiceOption({
              label: 'MISTOS: Raiz levemente oleosa e pontas secas.', value: '3: Mistos'
            })
          ]
        }),
        new QuestionModel({
          id: 'estruturaDosFios',
          title: 'Como você descreveria a estrutura dos seus fios?',
          type: QuestionType.MultipleChoice,
          multiple: false,
          helpText: 'Selecione a opção que melhor corresponde à condição atual dos seus fios de cabelo.',
          required: true,
          options: [
            new ChoiceOption({
              label: 'NATURAL', value: '1: Natural'
            }),
            new ChoiceOption({
              label: 'RESSECADOS, SEM BRILHO', value: '2: Ressecados e Sem Brilho'
            }),
            new ChoiceOption({
              label: 'DANIFICADOS, QUEBRADIÇOS', value: '3: Danificados (Quebradiços)'
            })
          ]
        }),
        new QuestionModel({
          id: 'curvatura',
          tagline: 'Selecione a opção que melhor representa a curvatura dos seus cabelos.',
          title: 'Curvatura dos fios:',
          helpTextShow: false,
          type: QuestionType.MultiplePictureChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/cabelo-liso.webp'),
              imageAlt: 'cabelo-liso',
              label: 'Cabelo Liso', value: '1: Liso'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/cabelo-ondulado.webp'),
              imageAlt: 'cabelo-ondulado',
              label: 'Cabelo Ondulado', value: '2: Ondulado'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/cabelo-cacheado.webp'),
              imageAlt: 'cabelo-cacheado',
              label: 'Cabelo Cacheado', value: '3: Cacheado'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/cabelo-crespo.webp'),
              imageAlt: 'cabelo-crespo',
              label: 'Cabelo Crespo', value: '4: Crespo'
            })
          ]
        }),
        new QuestionModel({
          id: 'texturaDosFios',
          tagline: 'Selecione a opção que melhor representa a espessura dos seus fios de cabelo.',
          title: 'Textura dos fios:',
          helpTextShow: false,
          type: QuestionType.MultiplePictureChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/fio-fino.jpg'),
              imageAlt: 'fio-fino',
              label: 'FINOS: Fios delicados e leves, com pouca resistência mecânica.', value: '1: Fino'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/fio-medio.jpg'),
              imageAlt: 'fio-medio',
              label: 'MÉDIOS: Fios com espessura padrão, nem muito finos nem muito espessos.', value: '2: Médio'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/fio-grosso.jpg'),
              imageAlt: 'fio-grosso',
              label: 'GROSSOS: Fios robustos e resistentes, com maior diâmetro.', value: '3: Grosso'
            })
          ]
        }),
        new QuestionModel({
          id: 'elasticidadeDosFios',
          title: 'Avaliação da Elasticidade dos fios:',
          type: QuestionType.MultipleChoice,
          multiple: false,
          helpText: 'Qual é a reatividade dos seus fios ao serem esticados?',
          required: true,
          options: [
            new ChoiceOption({
              label: 'BOA ELASTICIDADE: Os fios esticam e voltam ao normal.', value: '1: Boa Elasticidade'
            }),
            new ChoiceOption({
              label: 'SEM ELASTICIDADE: Os fios esticam, mas não voltam ao normal.', value: '2: Sem Elasticidade'
            }),
            new ChoiceOption({
              label: 'QUEBRA FACILMENTE: Os fios se partem quando esticados, indicando uma maior fragilidade.', value: '3: Fios Quebradiços'
            })
          ]
        }),
        new QuestionModel({
          id: 'processosQuimicos',
          title: 'Quais processos químicos costuma fazer?',
          type: QuestionType.MultipleChoice,
          multiple: true,
          helpText: 'Informe quais procedimentos químicos são habitualmente aplicados em seus cabelos:',
          required: true,
          allowOther: {
            label: 'Outro (Por favor, especifique)',
            enabled: true,
            value: '6: Outros'
          },
          options: [
            new ChoiceOption({
              label: 'DESCOLORAÇÃO, MECHAS, LUZES', value: '1: Descoloração (Mechas, Luzes)'
            }),
            new ChoiceOption({
              label: 'COLORAÇÃO', value: '2: Coloração'
            }),
            new ChoiceOption({
              label: 'PROGRESSIVA', value: '3: Progressiva'
            }),
            new ChoiceOption({
              label: 'SELAGEM', value: '4: Selagem'
            }),
            new ChoiceOption({
              label: 'RELAXAMENTO', value: '5: Relaxamento'
            })
          ]
        }),
        new QuestionModel({
          id: 'lavaCabelo',
          title: 'Rotina de Limpeza Capilar:',
          type: QuestionType.MultipleChoice,
          multiple: false,
          helpText: 'Com que frequência você lava seus cabelos?',
          required: true,
          options: [
            new ChoiceOption({
              label: 'TODOS OS DIAS', value: '1: Todos os Dias'
            }),
            new ChoiceOption({
              label: 'UMA VEZ POR SEMANA', value: '2: Uma Vez por Semana'
            }),
            new ChoiceOption({
              label: 'DIA SIM, DIA NÃO', value: '3: Dia Sim, Dia Não'
            })
          ]
        }),
        new QuestionModel({
          id: 'couroCabeludo',
          title: 'Condição do Couro Cabeludo:',
          type: QuestionType.MultipleChoice,
          multiple: false,
          helpText: 'Seu couro cabeludo apresenta algum dos seguintes sinais?',
          required: true,
          options: [
            new ChoiceOption({
              label: 'CASPA', value: '1: Caspa'
            }),
            new ChoiceOption({
              label: 'SEBORREIA', value: '2: Seborreia'
            }),
            new ChoiceOption({
              label: 'QUEDA', value: '3: Queda'
            }),
            new ChoiceOption({
              label: 'NÃO APRESENTA NENHUM DESSES SINAIS', value: '4: Não Apresenta Nenhum Desses Sinais'
            })
          ]
        }),
        new QuestionModel({
          id: 'secaCabelo',
          title: 'Método de Secagem do Cabelo:',
          type: QuestionType.MultipleChoice,
          multiple: false,
          helpText: 'Como você geralmente seca seu cabelo?',
          required: true,
          options: [
            new ChoiceOption({
              label: 'AO AR LIVRE (NATURALMENTE)', value: '1: Secam Naturalmente'
            }),
            new ChoiceOption({
              label: 'USANDO SECADOR', value: '2: Com Secador'
            }),
            new ChoiceOption({
              label: 'USANDO SECADOR E CHAPINHA', value: '3: Com Secador e Chapinha'
            })
          ]
        }),
        new QuestionModel({
          id: 'aniversario',
          tagline: 'Digite sua data de nascimento completa. Ex: 25/08/1994',
          title: 'Sua idade diz muito sobre seu cabelo: 👀',
          type: QuestionType.Phone,
          mask: '##/##/####',
          placeholder: 'dd/mm/aaaa',
          required: true
        }),
        new QuestionModel({
          id: 'perguntaIntencionalDesejo',
          title: 'Se seu cabelo ficasse do jeito que te faz se sentir incrível, como ele seria?',
          type: QuestionType.LongText,
          required: true,
          placeholder: '(Ex: hidratado e com volume controlado...)'
        }),
        new QuestionModel({
          id: 'respostaDiagnostico',
          tagline: 'Preferência de Recebimento do Diagnóstico:',
          title: 'Como você prefere receber seu diagnóstico?',
          helpTextShow: false,
          type: QuestionType.MultiplePictureChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/whatsApp.png'),
              imageAlt: 'WhatsApp',
              label: 'Por WhatsApp',
              value: 'Por WhatsApp'
            }),
            new ChoiceOption({
              imageSrc: require('@/assets/imagens/email.png'),
              imageAlt: 'Email',
              label: 'Por E-mail',
              value: 'Por E-mail'
            })
          ]
        }),
        // ===== CAMPO DE TELEFONE OTIMIZADO =====
        new QuestionModel({
          id: 'tel',
          tagline: 'Precisamos do seu WhatsApp para enviar o diagnóstico.',
          title: 'Qual é o seu WhatsApp?',
          type: QuestionType.Phone,
          mask: '(##) #####-####',
          required: true,
          placeholder: 'Ex: (31) 99999-8888',
          helpText: 'Digite apenas números com DDD'
        }),
        new QuestionModel({
          id: 'termoUso',
          title: 'Pronto para receber seu diagnóstico!',
          type: QuestionType.MultipleChoice,
          options: [
            new ChoiceOption({
              label: 'Quero receber meu diagnóstico',
              value: 'on'
            })
          ],
          required: true,
          multiple: false,
          description: 'Ao continuar, você aceita nossa',
          descriptionLink: [
            new LinkOption({
              url: 'https://loja.leportini.com.br/pagina/privacidade-e-termos-de-uso.html',
              text: 'Política de Privacidade.',
              target: '_blank'
            })
          ]
        })
      ]
    }
  },
  mounted() {
    document.addEventListener('keyup', this.onKeyListener)

    // Guarda a query atual (last touch da sessão)
    const qs = window.location.search || ''
    if (qs) {
      sessionStorage.setItem('lp_last_qs', qs)
    }

    // Backup: se vier com query e ainda não tiver first touch, salva
    if (qs && !localStorage.getItem('lp_ft_qs')) {
      localStorage.setItem('lp_ft_qs', qs)
      localStorage.setItem('lp_ft_ts', String(Date.now()))
    }
    this.startInvalidPromptWatcher()
  },

  beforeUnmount() {
    document.removeEventListener('keyup', this.onKeyListener)
    this.stopInvalidPromptWatcher()
  },

  methods: {
    onKeyListener($event) {
      if ($event.key === 'Enter' && this.completed && !this.submitted) {
        this.onSendData()
      }
    },
    
    startInvalidPromptWatcher() {
      this.stopInvalidPromptWatcher()
      this._vffLastQid = null

      this._vffTimer = setInterval(() => {
        const ff = this.$refs.flowform
        if (!ff) return

        const q =
          ff.activeQuestion ||
          ff.currentQuestion ||
          ff.question ||
          (typeof ff.getActiveQuestion === 'function' ? ff.getActiveQuestion() : null)

        const qid =
          (q && q.id) ||
          ff.activeQuestionId ||
          ff.currentQuestionId ||
          ff.questionId

        if (!qid) return
        if (qid === this._vffLastQid) return

        this._vffLastQid = qid

        // Mensagens de erro personalizadas e otimizadas
        const prompts = {
          aniversario: 'Digite a data no formato dd/mm/aaaa. Ex: 25/08/1994',
          emailFeminino: 'Digite um e-mail válido. Ex: nome@dominio.com',
          emailMasculino: 'Digite um e-mail válido. Ex: nome@dominio.com',
          tel: 'Digite seu WhatsApp com DDD. Ex: (31) 99999-8888'
        }

        this.language.invalidPrompt = prompts[qid] || this.defaultInvalidPrompt
      }, 150)
    },

    stopInvalidPromptWatcher() {
      if (this._vffTimer) {
        clearInterval(this._vffTimer)
        this._vffTimer = null
      }
    },

    onComplete(completed) {
      this.completed = completed
    },

    onSubmit() {
      this.onSendData()
    },

    // Controla obrigatoriedade do telefone
    onAnswer(questionAnswered) {
      if (!questionAnswered || !questionAnswered.id) return

      const telQuestion = this.questions.find(q => q.id === 'tel')
      if (!telQuestion) return

      if (questionAnswered.id === 'respostaDiagnostico') {
        const preferencia = questionAnswered.answer
        telQuestion.required = (preferencia === 'Por WhatsApp')
      }
    },

    obterUrlAtualComUtms() {
      try {
        const qsNow = window.location.search || ''
        const qsSession = sessionStorage.getItem('lp_last_qs') || ''
        const qsFirst = localStorage.getItem('lp_ft_qs') || ''
        const qs = qsNow || qsSession || qsFirst

        const base = window.location.origin + window.location.pathname
        return qs ? (base + qs) : window.location.href.toString()
      } catch (error) {
        console.error('Erro ao obter a URL atual com parâmetros UTM:', error)
        return window.location.href.toString()
      }
    },

    // Método para enviar dados para o webhook e acionar eventos de conversão
    onSendData(){
      const answers = this.questions.reduce((acc, question) =>{
        acc[question.id] = question.answer || ''
        return acc
      }, {})

      answers.urlAtual = this.obterUrlAtualComUtms()

      // Seleciona o WhatsApp aleatório ANTES de enviar o payload
      const numeros = [
        '553398460017'
      ]
      const numeroEscolhido = numeros[Math.floor(Math.random() * numeros.length)]
      answers.numeroWhatsappEscolhido = numeroEscolhido

      const webhookUrl = 'https://nwebhook.leportini.com.br/webhook/d937d412-9ab9-4154-af3b-f3581ea5'
      
      // Origem do contato/lead (first touch)
      const origem = this.obterOrigemLead()
      
      answers.origem_lead = origem.origemLead
      answers.ft_utm_source = origem.utm_source
      answers.ft_utm_medium = origem.utm_medium
      answers.ft_utm_campaign = origem.utm_campaign
      answers.ft_utm_content = origem.utm_content
      answers.ft_utm_term = origem.utm_term

      answers.ft_fbclid = origem.fbclid
      answers.ft_gclid = origem.gclid
      answers.ft_wbraid = origem.wbraid
      answers.ft_gbraid = origem.gbraid

      answers.ft_referrer = origem.referrer
      answers.ft_landing_path = origem.landingPath
      answers.ft_landing_url = origem.landingUrl
      
      // Formata telefone com +55
      const telRaw = answers.tel || ''
      const digits = telRaw.replace(/\D/g, '')

      // aceita 10 ou 11 dígitos nacionais e normaliza para 55 + dígitos
      if (digits.length === 10 || digits.length === 11) {
        answers.tel = '55' + digits
      } else if (digits.startsWith('55') && (digits.length === 12 || digits.length === 13)) {
        answers.tel = digits
      } else {
        answers.tel = ''
      }

      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(answers)
      })
        .then(response => {
          if (response.ok) {
            this.submitted = true
            console.log('Dados enviados com sucesso.')

            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'Lead',
                form_data: answers
              })
            }

            window.onbeforeunload = null
            setTimeout(() => {
              window.open(`https://wa.me/${numeroEscolhido}?text=Quero%20acessar%20meu%20diagnostico`, '_blank')
            }, 2000)
          } else {
            console.error('Falha ao enviar dados.')
          }
        })
        .catch(error => console.error('Erro:', error))
    },
    
    obterOrigemLead() {
      const qsNow = window.location.search || ''
      const qsSession = sessionStorage.getItem('lp_last_qs') || ''
      const qsFirst = localStorage.getItem('lp_ft_qs') || ''

      const qs = (qsNow || qsSession || qsFirst || '')
      const params = new URLSearchParams(qs)

      const utm_source = params.get('utm_source') || ''
      const utm_medium = params.get('utm_medium') || ''
      const utm_campaign = params.get('utm_campaign') || ''
      const utm_content = params.get('utm_content') || ''
      const utm_term = params.get('utm_term') || ''

      const fbclid = params.get('fbclid') || ''
      const gclid = params.get('gclid') || ''
      const wbraid = params.get('wbraid') || ''
      const gbraid = params.get('gbraid') || ''

      const referrer = document.referrer || ''
      const landingPath = window.location.pathname || ''
      const landingUrl = (window.location.origin + window.location.pathname + (qs || '')) || window.location.href || ''

      let origemLead = 'Direto/Desconhecido'

      const source = (utm_source || '').toLowerCase()
      const medium = (utm_medium || '').toLowerCase()
      const ref = (referrer || '').toLowerCase()

      if (source.includes('meta') || source.includes('facebook') || source.includes('instagram')) {
        origemLead = 'Meta (Facebook/Instagram)'
      } else if (ref.includes('facebook.com') || ref.includes('instagram.com') || ref.includes('l.facebook.com')) {
        origemLead = 'Meta (Facebook/Instagram) - Referrer'
      } else if (source.includes('google') || medium.includes('cpc') || medium.includes('ppc')) {
        origemLead = 'Google Ads'
      } else if (ref.includes('google.') && !ref.includes('googleads')) {
        origemLead = 'Google Orgânico'
      } else if (origemLead === 'Direto/Desconhecido' && referrer) {
        origemLead = 'Referência (site externo)'
      }

      return {
        origemLead,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        fbclid,
        gclid,
        wbraid,
        gbraid,
        referrer,
        landingPath,
        landingUrl
      }
    }
  }
}
</script>

<style lang="css">
/* CSS do FlowForm será importado via package */
/* @import '@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'; */
</style>
